import React from "react";
import home from "./../../../img/fondo.png";

const Dashboard = () => {
  return (
    <>
      <img
        src={home}
        alt="home"
        style={{
          width: "100%",
          height: "100%", // Reemplaza con la URL de tu imagen de fondo
          backgroundSize: "cover",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      />
    </>
  );
};

export default Dashboard;

